import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const EVENT_TYPES = [
  "support_request",
  "bug_report",
  "billing_issue",
  "feature_request",
  "complaint",
  "cancellation_risk",
  "onboarding_help",
  "other",
] as const;

const PRIORITIES = ["low", "normal", "high", "urgent"] as const;

const schema = z.object({
  name: z.string().trim().min(2).max(120),
  email: z.string().trim().email().max(200),
  company: z.string().trim().max(200).optional().or(z.literal("")),
  phone: z.string().trim().max(40).optional().or(z.literal("")),
  event_type: z.enum(EVENT_TYPES),
  priority: z.enum(PRIORITIES),
  subject: z.string().trim().min(2).max(200),
  description: z.string().trim().min(5).max(5000),
  preferred_contact_method: z.string().trim().max(40).optional().or(z.literal("")),
  page_url: z.string().max(500).optional().or(z.literal("")),
  user_agent: z.string().max(500).optional().or(z.literal("")),
  submission_id: z.string().uuid(),
  website: z.string().max(200).optional().or(z.literal("")),
});

export const submitSupportRequest = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => schema.parse(data))
  .handler(async ({ data }) => {
    if (data.website) return { ok: true }; // honeypot

    const payload = {
      source: "venture_external_support",
      venture_hint: "clutchcube",
      email: data.email,
      full_name: data.name,
      company: data.company || undefined,
      phone: data.phone || undefined,
      event_type: data.event_type,
      priority: data.priority,
      summary: data.subject,
      submission_id: data.submission_id,
      data: {
        description: data.description,
        preferred_contact_method: data.preferred_contact_method || undefined,
        page_url: data.page_url || undefined,
        user_agent: data.user_agent || undefined,
        submitted_from: "this venture website",
      },
    };

    try {
      const res = await fetch("https://venturexos.com/api/public/cios/ingest", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const text = await res.text();
      let json: any = null;
      try { json = JSON.parse(text); } catch {}
      if (!res.ok || !json?.ok) {
        console.error("CIOS ingest failed", res.status, text);
        return { ok: false as const, error: "Unable to submit support request. Please try again." };
      }
      return { ok: true as const };
    } catch (err) {
      console.error("CIOS ingest error", err);
      return { ok: false as const, error: "Network error. Please try again." };
    }
  });
